import React, { ReactElement } from 'react';
import { Typography } from '../Typography/Typography';
import classNames from 'classnames/bind';
import styles from './Card.module.scss';
import EllipsisMenu from '../EllipsisMenu/EllipsisMenu';
import { IOption } from '../Dropdown/Dropdown';
import { Link } from 'react-router-dom';
import { IIconProps } from '../../assets/icons/types';

const cx = classNames.bind(styles);

export interface ICard {
  text: string;
  subtext?: string;
  subtextColor?: 'primary' | 'secondary';
  to?: string;
  imageSrc?: string;
  ellipsisOptions?: IOption[];
  variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary';
  icon?: ReactElement<IIconProps>;
  dataTestId?: string;
}

const Card = ({
  text,
  subtext,
  subtextColor = 'primary',
  to,
  imageSrc,
  ellipsisOptions,
  variant = 'primary',
  icon,
  dataTestId,
}: ICard) => {
  // Clone the icon element with a new width prop
  const iconWithWidth =
    icon &&
    React.cloneElement(icon, {
      size: 'extra-large',
    });
  const cardContent = (
    <div
      className={cx('card')}
      style={imageSrc ? { backgroundImage: `url(${imageSrc})` } : undefined}
      data-testid={dataTestId}
    >
      <div className={cx('card-content')}>
        {imageSrc ? (
          <div className={cx('card-icon-container')}></div>
        ) : (
          <div className={cx('card-icon-container', variant)}>
            <div className={cx('card-icon')} data-testid={'card-icon'}>
              {iconWithWidth}
            </div>
          </div>
        )}
        <div className={cx('card-text-container')}>
          <Typography className={cx('card-title')} size="XS" weight="semi-bold">
            {text.length > 50 ? `${text.slice(0, 50)}...` : text}
          </Typography>
          {subtext && (
            <Typography className={cx('card-subtitle')} size="XS" weight="regular" color={subtextColor}>
              {subtext.length > 25 ? `${subtext.slice(0, 22)}...` : subtext}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className={cx('card-wrapper')}>
      {to ? (
        <Link to={to} className={cx('card-link')}>
          {cardContent}
        </Link>
      ) : (
        <>{cardContent}</>
      )}

      {ellipsisOptions && (
        <div className={cx('card-menu')} onClick={(e) => e.stopPropagation()}>
          <EllipsisMenu options={ellipsisOptions} variant="solid" colour="kale" />
        </div>
      )}
    </div>
  );
};

export default Card;
